import { attr, Model } from 'redux-orm';
import generateRandomString from '%app/js/common/services/generateRandomString';
import transformation from '../defaults/transformation';
import polygon from '../defaults/polygon';

class BaseModel extends Model {
    static fields = {
        id: attr(),
        transformation: attr({ getDefault: () => transformation }),
        compiled: attr({
            getDefault: () => ({
                polygon,
            }),
        }),
        index: attr({ getDefault: () => 0 }),
        hash: attr({ getDefault: () => generateRandomString() }),
        cacheKey: attr({ getDefault: () => generateRandomString() }),
    };

    toString() {
        return `${this.modelName}: ${this.label.text ? this.label.text : this.id}`;
    }
}

export default BaseModel;
